import React from 'react'
import Appbar from 'components/Appbar'
import { PageContent } from '@ui'
import { NavigateFn } from '@reach/router'
import Settings from './Settings'

type SettingsPageProps = {
  id: string
  navigate?: NavigateFn
}

export default function SettingsPage({ id, navigate }: SettingsPageProps) {
  return (
    <>
      <Appbar title="Settings" />
      <PageContent>
        <Settings id={id} navigate={navigate} />
      </PageContent>
    </>
  )
}
